import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        close: '&',
        onUpdate: '&'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.close()"></button>
            <h2>{{ 'user.Anonymize data for inactive users' | translate }}</h2>
        </div>
        <div class="modal-body">
            <div class="form">
            <div class="alert alert-warn">
                {{ 'user.Personal data for all users that have been deactivated before the selected date will be anonymized.' | translate }}</br>
                {{ 'user.The data in question includes:' | translate }}
                <ul>
                    <li>{{ 'user.Name' | translate}}</li>
                    <li>{{ 'user.Phone' | translate}}</li>
                    <li>{{ 'user.Personal code' | translate}}</li>
                    <li>{{ 'user.Email' | translate}}</li>
                </ul>
                <span ng-bind-html="vm.getTranslation()"></span>
            </div>
                <form-row error="vm.form.errors.inactivityPeriods[0].start">
                    <label class="label" style="align-items: flex-start;display: inline-flex;padding-right:40px;">
                        {{ 'user.Latest termination of employment contract' | translate }}
                        <tooltip html="vm.tooltipTexts.deactivation" />
                    </label>
                    <div class="items mt10" style="margin-bottom:10px">
                        <datepicker-api
                            ng-change="vm.getAffectedUserNumber()"
                            ng-model="vm.dateBefore"
                        ></datepicker-api>
                        <form-row-error></form-row-error>
                        <div style="margin-top:20px;" ng-if="vm.affectedUsers !== null && vm.affectedUsers >= 0 && !vm.loading">
                            <b>{{ vm.affectedUsers }} {{ 'user.users affected' | translate }}</b>
                        </div>
                    </div>
                </form-row>
            </div>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button
                        class="btn main"
                        type="button"
                        ng-click="vm.save()"
                        ng-class="{'loading': vm.loading}"
                        ng-disabled="vm.loading"
                    >
                        {{ 'general.Save' | translate }}
                    </button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.close()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor (UserResource, toastr, $translate) {
        this.UserResource = UserResource;
        this.toastr = toastr;
        this.$translate = $translate;
        this.affectedUsers = null;

        this.tooltipTexts = {
            deactivation: this.$translate.instant('user.Deactivation date tooltip')
        };
    }

    getTranslation () {
        return this.$translate.instant('user.All training data will remain in Coursy for statistical purposes');
    }

    getAffectedUserNumber () {
        setTimeout(() => {
            this.save(true);
        }, 200);
    }

    save (dryRun = false) {
        this.loading = true;
        this.UserResource.anonymizeEmployees({}, { dateBefore: this.dateBefore, dryRun }).$promise.then((response) => {
            this.affectedUsers = response.count;

            if (!dryRun) {
                const msg = this.$translate.instant('user.import.Updated {userCount} employees', { userCount: response.count });
                this.toastr.success(msg);
                this.close();
            }
        }).catch((errors) => {
            // console.log(errors);
            this.errors = errors;
            if (!dryRun) {
                errors.data.map((error) => this.toastr.error(error.message));
            }
        }).finally(() => {
            this.loading = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/employee/anonymizeEmployees/index.js